import React, { Component, Fragment } from "react";
/* Helpers */
import utils from "../../../../modules/utils";
/* Components */
import FormRadioButton from "../FormRadioButton/index";

class FormAuxiliaryInfo extends Component {
  render() {
    const global_state = utils.getState();
    const { errors } = this.props.currentState;
    let infoSection = null;
    let prod = parseInt(global_state.prodotto);
    switch (prod) {
      case -1:
      case 3:
        infoSection = (
          <Fragment>
            <h2>Che tipo di impiego hai?</h2>
            <div className="grid-container">
              <div className="grid-x grid-padding-x">
                <div className="cell medium-10 medium-offset-1">
                  <div className="grid-x grid-padding-x" id="radio-impiego">
                    <div className={"cell medium-4 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Autonomo"
                        value="1"
                      />
                    </div>
                    <div className={"cell medium-4 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Dipendente pubblico/statale"
                        value="2"
                      />
                    </div>
                    <div className={"cell medium-4 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Dipendente SPA/SRL (+15 dipendenti)"
                        value="2"
                      />
                    </div>
                    <div className={"cell medium-4 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Dipendente SPA/SRL (-15 dipendenti)"
                        value="2"
                      />
                    </div>
                    <div className={"cell medium-4 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Dipendente SNC/SAS"
                        value="2"
                      />
                    </div>
                    <div className={"cell medium-4 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Pensionato"
                        value="3"
                      />
                    </div>
                    <div className={"cell medium-4 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Altro"
                        value="4"
                      />
                    </div>
                    <div className="error">{errors["impiego"]}</div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
        break;
      case 5:
        infoSection = (
          <Fragment>
            <div className="form-dati-personali__question">
              <h2>Sei iscritto alla Camera di Commercio da almeno due anni?</h2>
              <div className="grid-container">
                <div className="grid-x grid-padding-x">
                  <div className="cell medium-6 medium-offset-3">
                    <div className="grid-x grid-padding-x" id="radio-impiego">
                      <div
                        className={"cell medium-6 " + this.props.valid_class}
                      >
                        <FormRadioButton
                          handler={this.props.handleCheck}
                          validate="rb"
                          name="iscrittoCameraCommercio"
                          label="Si, sono iscritto"
                          value={true}
                        />
                      </div>
                      <div
                        className={"cell medium-6 " + this.props.valid_class}
                      >
                        <FormRadioButton
                          handler={this.props.handleCheck}
                          validate="rb"
                          name="iscrittoCameraCommercio"
                          label="No, non sono iscritto"
                          value={false}
                        />
                      </div>
                      <div className="error">
                        {errors["iscrittoCameraCommercio"]}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-dati-personali__question">
              <h2>Tipo di azienda?</h2>
              <div className="grid-container">
                <div className="grid-x grid-padding-x">
                  <div className="cell medium-6 medium-offset-3">
                    <div className="grid-x grid-padding-x" id="radio-impiego">
                      <div
                        className={"cell medium-6 " + this.props.valid_class}
                      >
                        <FormRadioButton
                          handler={this.props.handleCheck}
                          validate="rb"
                          name="tipoAzienda"
                          label="Società"
                          value="società"
                        />
                      </div>
                      <div
                        className={"cell medium-6 " + this.props.valid_class}
                      >
                        <FormRadioButton
                          handler={this.props.handleCheck}
                          validate="rb"
                          name="tipoAzienda"
                          label="Ditta individuale"
                          value="ditta individuale"
                        />
                      </div>
                      <div className="error">{errors["tipoAzienda"]}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
        break;
      default:
        infoSection = (
          <Fragment>
            <h2>Che tipo di impiego hai?</h2>
            <div className="grid-container">
              <div className="grid-x grid-padding-x">
                <div className="cell medium-6 medium-offset-3">
                  <div className="grid-x grid-padding-x" id="radio-impiego">
                    <div className={"cell medium-6 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Dipendente"
                        value="2"
                      />
                    </div>
                    <div className={"cell medium-6 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Autonomo"
                        value="1"
                      />
                    </div>
                    <div className={"cell medium-6 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Pensionato"
                        value="3"
                      />
                    </div>
                    <div className={"cell medium-6 " + this.props.valid_class}>
                      <FormRadioButton
                        handler={this.props.handleCheck}
                        validate="rb"
                        name="impiego"
                        label="Altro"
                        value="4"
                      />
                    </div>
                    <div className="error">{errors["impiego"]}</div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
    }

    return (
      <section className="form-dati-personali__info">{infoSection}</section>
    );
  }
}

export default FormAuxiliaryInfo;



// WEBPACK FOOTER //
// ./src/components/dati_personali/components/FormAuxiliaryInfo/index.js